import React from "react";
import "./Services.css";
import { BsCheck } from "react-icons/bs";
function Services() {
  return (
    <section id="services">
      <h5>What I Offer</h5>
      <h2>Services</h2>
      <div className="container services__container">
        {/* START OF UI/UX  */}
        <article className="service">
          <div className="service__head">
            <h3>UI/UX Design</h3>
          </div>
          <ul className="service__list">
            <li>
              <BsCheck className="service__list-icon" />
              <p>User interface design</p>
            </li>
            <li>
              <BsCheck className="service__list-icon" />
              <p>User experience design</p>
            </li>
            <li>
              <BsCheck className="service__list-icon" />
              <p>Interaction & Responsive design</p>
            </li>
          </ul>
        </article>
        {/* END OF UI/UX  */}
        {/* START OF WEB DEVELOPMENT  */}
        <article className="service">
          <div className="service__head">
            <h3>Web Development</h3>
          </div>

          <ul className="service__list">
            <li>
              <BsCheck className="service__list-icon" />
              <p>E-commerce Websites</p>
            </li>
            <li>
              <BsCheck className="service__list-icon" />
              <p>Portfolio Websites</p>
            </li>
            <li>
              <BsCheck className="service__list-icon" />
              <p>Events Websites</p>
            </li>
            <li>
              <BsCheck className="service__list-icon" />
              <p>Social Networking Websites</p>
            </li>
            <li>
              <BsCheck className="service__list-icon" />
              <p>Personalised Websites</p>
            </li>
          </ul>
        </article>
        {/* END OF WEB DEVELOPMENT  */}
        {/* START OF API DEVELOPMENT */}
        <article className="service">
          <div className="service__head">
            <h3>API Development</h3>
          </div>

          <ul className="service__list">
            <li>
              <BsCheck className="service__list-icon" />
              <p>I have expertise in building APIs</p>
            </li>
            <li>
              <BsCheck className="service__list-icon" />
              <p>I develop RESTful APIs</p>
            </li>
          </ul>
        </article>
        {/* END OF API DEVELOPMENT  */}
      </div>
    </section>
  );
}

export default Services;
